import {FormBuilder} from '@angular/forms/forms';
import {Layer, LayerType} from './layer';
import {GeospatialFilterStore} from '../api/geospatial-filter.store';

export class SystemLayer extends Layer {
    constructor(
        public fb: FormBuilder,
        public geospatialFilterStore: GeospatialFilterStore,
        public visible: boolean = true,
        public expanded: boolean = false,
    ) {
        super('System Layer', LayerType.SYSTEM, fb, geospatialFilterStore, visible, expanded);
    }
}
